import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const Profil = lazy(() => import("@/pages/mina-sidor/Profil"));

export const Route = createFileRoute("/mina-sidor/profil")({
  component: () => <Profil />,
});
